angular.module('ib-rental-car-module', []);